import { PhantomWalletName } from '@solana/wallet-adapter-wallets';
import { WalletReadyState } from '@solana/wallet-adapter-base';
import { DriftWalletName } from 'src/constants/wallets';
import { WalletToDisplayInfo } from 'src/hooks/useWalletsToDisplay';
import { MoreWalletsCta } from '../../../ConnectWalletButtonsList';
import { WalletButton } from 'src/components/ConnectWalletButtonsList/WalletButton';

export const MainWalletsPage = (props: {
	wallets: WalletToDisplayInfo[];
	hiddenWallets: WalletToDisplayInfo[];
	onChooseWallet: (walletName: DriftWalletName) => void;
	onShowMoreWallets: () => void;
}) => {
	return (
		<div className="flex flex-col gap-y-8 pb-2xl not-sm:h-full not-sm:justify-between">
			<div className="flex flex-col gap-y-md">
				{props.wallets.map((walletProvider) => (
					<WalletButton
						onChooseWallet={() => {
							if (
								walletProvider.provider.adapter.name === PhantomWalletName &&
								walletProvider.provider.readyState !==
									WalletReadyState.Installed
							) {
								window.open(
									'https://phantom.com/download',
									'_blank',
									'noopener,noreferrer'
								);
								return;
							}

							props.onChooseWallet?.(walletProvider.provider.adapter.name);
						}}
						wallet={walletProvider}
						key={walletProvider.provider.adapter.name}
					/>
				))}
			</div>
			<MoreWalletsCta
				onClick={props.onShowMoreWallets}
				wallets={props.hiddenWallets}
			/>
		</div>
	);
};
